import { Component } from "preact";
import PropTypes from "prop-types";
import { combineClasses, get } from "@green24/npm-javascript-utils";
import { withStoreConnection } from "../../components/components";
import Loading from "../../components/shared/Loading";
import ErrorBlock from "../../components/shared/ErrorBlock";
import { configurationSelector, settingsSelector } from "../../store/selectors/selectors";
import { settingsThunk } from "../../store/store";
import Interpret from "../../components/shared/Localization/Interpret";
import Fa from "../../components/shared/Fa";

class InformationPage extends Component {
	componentDidMount() {
		this._fetchHelp();
	}

	_renderContent() {
		const {fetching, error, settings} = this.props;

		if(fetching) {
			return <Loading block={true} style={{width: "100%"}}/>;
		}

		if(error) {
			return <ErrorBlock error={error} onRetry={() => this._fetchHelp()}/>;
		}

		const hotlineNumber = get(settings, "publicContact.landLine", get(settings, "publicContact.cellPhone"));
		const email = get(settings, "publicContact.contactEmail");

		return (
			<>
				<div className={"contact"}>
					<hr/>

					{
						hotlineNumber &&
						<div>
							<div className={"support.hotline"}>
								<Fa icon={"phone-square-alt"}/>
								<h2><Interpret id={"support.hotline"}/></h2>
								<p>
									<Interpret id={"support.hotline.message"}/>
									<br/>

									<b><Interpret id={settings.hotlineInfo}/></b>
								</p>

								<h1>{hotlineNumber}</h1>
							</div>
						</div>
					}
					{
						email &&
						<div>
							<div className={"email"}>
								<Fa icon={"envelope-square"}/>
								<h2><Interpret id={"email"}/></h2>
								<p><Interpret id={"support.email.message"}/></p>

								<h1>{email}</h1>
							</div>
						</div>
					}
				</div>

				{/*
				FFS: Temporary removed
				<div className={"terms-button-wrapper"}>
					<ButtonsConstructor buttons={[
						{
							text: "termsAndConditions",
							className: "accent-fill primary",
							href: E_Route.TERMS,
						}
					]}/>
				</div>
				*/}
			</>
		);
	}

	render({className, style}) {
		return (
			<section className={combineClasses("information-page", className)} style={style}>
				{this._renderContent()}
			</section>
		);
	}

	_fetchHelp() {
		settingsThunk.get(this.props.locationID);
	}

	static get propTypes() {
		return {
			className: PropTypes.string,
			style: PropTypes.object,
			children: PropTypes.any,

			//Store
			fetching: PropTypes.bool,
			error: PropTypes.object,
			settings: PropTypes.object,
			locationID: PropTypes.number,
		}
	}
}

const mapStateToProps = state => {
	let {fetching, error} = settingsSelector.selectRoot(state);
	let settings = settingsSelector.selectData(state);
	const { locationID } = configurationSelector.selectData(state);

	return {
		fetching,
		error,
		settings,
		locationID,
	};
};

export default withStoreConnection(mapStateToProps)(InformationPage);
